module.exports = "<div class=\"wrapper\">\n\n  <div class=\"bar\">\n    <olapic-logo></olapic-logo>\n  </div>\n\n  <div class=\"content login\">\n    <div>\n      <div class=\"login-error\" ng-if=\"$ctrl.error\"> Authentication failure: {{$ctrl.error}} </div>\n      <button ng-click=\"$ctrl.loginWithGoogle()\"><span>LOGIN with your @olapic Google account</span></button>\n    </div>\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/login/login.html
// module id = 46
// module chunks = 0